import { ButtonLink } from '@common/components/atoms/Buttons';
import React from 'react';

export const NoFound = () => (
  <div className="text-center m-auto p-4 md:p-40 bg-unaula-gray">
    <h1 className="text-xl md:text-2xl mb-6">Upss, la página solicitada no existe</h1>
    <ButtonLink to="/" replace>Regresar al inicio</ButtonLink>
  </div>
);
